/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";
import router from "@/router";
import { createPinia } from "pinia";
import Tres from "@tresjs/core";

// Configure Vuetify
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#5f977a",
          primaryDark: "#4a755f",
          secondary: "#90c09a",
          secondaryLight: "#b3dcbf",
          secondaryLighter: "#d6f2e4",
          background: "#f2f4d3",
          contrast: "#8f277d",
          dark: "#303030",
          surface: "#ffffff",
        },
      },
    },
  },
});

const pinia = createPinia();

export function registerPlugins(app) {
  app.use(vuetify).use(router).use(pinia).use(Tres);
}
